import { Component, Input } from '@angular/core';
import { CDFTState } from 'app/modules/cdft/state/cdft.state';
import { CdftStatus } from 'app/modules/cdft/model/cdft.model';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import module from 'app/modules/cdft/cdft.module';

@Component({
    selector: 'app-cdft-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss'],
    standalone: true,
    imports: module,
})
export class DetailComponent {
    @Input() isViewOnly: boolean;

    formGroup: FormGroup;
    cdftStatus = CdftStatus;
    private subscriptions: Subscription = new Subscription();
    constructor(private formBuilder: FormBuilder, public state: CDFTState) { }

    ngOnInit() {
        this.formGroup = this.onFormGroup();
        this.state.setFormGroup('detail', this.formGroup);
        this.onPopulate();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    onPopulate() {
        const cdftState = this.state.subscribe((cdft: CDFTState) => {
            this.formGroup.patchValue({
                result: this.state.result,
                status: this.state.status,
                prodStatus: cdft?.cdftHeader?.wellStatus ?? ''
            });
        });

        this.subscriptions.add(cdftState);
    }

    onFormGroup() {
        return this.formBuilder.group({
            result: new FormControl({ value: null, disabled: this.isViewOnly }),
            status: new FormControl({ value: null, disabled: this.isViewOnly }),
            prodStatus: new FormControl({ value: null, disabled: this.isViewOnly }),
        });
    }
}
